import * as Yup from "yup";

export const securitySchema = Yup.object({

    security_deposit: Yup.string().required("Select Deposit"),
    amount: Yup.string().required("Enter Deposit Amount"),

});